import { useMutation } from "@tanstack/react-query";
import { generateDayBookReport } from "services/daybook";

export const useGenerateDayBookReport = () => {
  const mutation = useMutation({
    mutationFn: (reportData) => generateDayBookReport(reportData),
  });
  return mutation;
};

